import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, IProtocoloFicState } from './types';

export const INITIAL_STATE: IProtocoloFicState = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): IProtocoloFicState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.PROTOCOLO_FIC_REQUEST: {
				break;
			}
			case Types.PROTOCOLO_FIC_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}
			case Types.PROTOCOLO_FIC_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.PROTOCOLO_FIC_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
